import React from "react";
import { Outlet } from "react-router-dom";
import Head from "./head/Head";

const Layout = ({ title, ...props }) => {

  return (
    <>
      <Head title={!title && 'Loading'} />
      <div
        className="nk-app-root"
        style={{
          minHeight: "100vh",
          backgroundColor: "#f1f5f9",
          backgroundAttachment: "fixed",
          backgroundImage: `
      radial-gradient(circle at 30% 20%, rgba(0,0,0,0.04), transparent 40%),
      repeating-linear-gradient(
        45deg,
        rgba(0,0,0,0.025),
        rgba(0,0,0,0.025) 1px,
        transparent 1px,
        transparent 16px
      )
    `,
        }}
      >

        <div className="nk-wrap nk-wrap-nosidebar">
          <div className="nk-content">
            <Outlet />
          </div>
        </div>
      </div>
    </>
  );
};
export default Layout;;